import React from 'react'
// import PropTypes from 'prop-types';

const ArtistsTotal = () => (
  <div>
    <h6>ArtistsTotal ArtistsTotal ArtistsTotal</h6>
  </div>
)

// ArtistsTotal.propTypes = {};

export default ArtistsTotal
